import { useWebSettings } from "@/models/StateProviders/WebSettingsProvider";

/**
 * Whether a new task may be about a message or event rather than its driver: the workspace's `web.dispatch.itemTasks`.
 *
 * A gate on making tasks alone: a task already about a message or event still displays, folds, moves, and is
 * acknowledged with it off. It matters only while {@link useTasksEnabled} is on. No browser-local override: the flag is
 * the workspace's, and a member cannot set it.
 */
export function useItemTasksEnabled(): boolean {
  return useWebSettings().settings.dispatch.itemTasks;
}
